export const REQUEST_CREATE_DEMO_ACCESS = 'REQUEST_CREATE_DEMO_ACCESS';
export const RECEIVE_CREATE_DEMO_ACCESS = 'RECEIVE_CREATE_DEMO_ACCESS';
export const RECEIVE_CREATE_DEMO_ACCESS_ERROR = 'RECEIVE_CREATE_DEMO_ACCESS_ERROR';
